import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ShopProvider } from "./context/ShopContext";
import "./css/App.css";
import "./css/admin.css";
import "./css/header.css";
import "./css/footer.css";
import "./css/home.css";
import "./css/products.css";
import "./css/sectionPage.css";
import "./css/shop.css";
import "./css/contact.css";
import "./css/legal.css";
import "./css/responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <AuthProvider>
        <ShopProvider>
          <App />
        </ShopProvider>
      </AuthProvider>
    )
  }
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
